/**
 * Sprint API Documentation
 * Sprint API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: developer@sprintapp.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { CreateMemberGeneralMissionRequest } from '../model/createMemberGeneralMissionRequest';
// @ts-ignore
import { DailyMemberGeneralMissionGroupRecord } from '../model/dailyMemberGeneralMissionGroupRecord';
// @ts-ignore
import { MemberGeneralMissionRecord } from '../model/memberGeneralMissionRecord';
// @ts-ignore
import { MemberMissionStatusType } from '../model/memberMissionStatusType';
// @ts-ignore
import { PageMemberGeneralMissionRecord } from '../model/pageMemberGeneralMissionRecord';
// @ts-ignore
import { RemoveMemberGeneralMissionCompletionByDateRequest } from '../model/removeMemberGeneralMissionCompletionByDateRequest';
// @ts-ignore
import { SliceMemberGeneralMissionRecord } from '../model/sliceMemberGeneralMissionRecord';
// @ts-ignore
import { UpdateMemberGeneralMissionRecurrencePatternRequest } from '../model/updateMemberGeneralMissionRecurrencePatternRequest';
// @ts-ignore
import { UpdateMemberGeneralMissionRequest } from '../model/updateMemberGeneralMissionRequest';
// @ts-ignore
import { UpsertMemberGeneralMissionCompletionByDateRequest } from '../model/upsertMemberGeneralMissionCompletionByDateRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class MemberGeneralMissionService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
            if (firstBasePath != undefined) {
                basePath = firstBasePath;
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString());
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * MemberGeneralMission 활성화
     * ### HasAny authorities: - Expert - SilverMember - BronzeMember  ### Possible domain exceptions: 
     * @param id 
     * @param version 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public activateMemberGeneralMission(id: string, version?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<string>;
    public activateMemberGeneralMission(id: string, version?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<string>>;
    public activateMemberGeneralMission(id: string, version?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<string>>;
    public activateMemberGeneralMission(id: string, version?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling activateMemberGeneralMission.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (version !== undefined && version !== null) {
            localVarHeaders = localVarHeaders.set('Version', String(version));
        }

        let localVarCredential: string | undefined;
        // authentication (sprint-backoffice-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-backoffice-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-expert-manager-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-expert-manager-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-member-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-member-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-expert-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-expert-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/member-general-missions/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/activate`;
        return this.httpClient.request<string>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Mission을 종료합니다.
     * ### HasAny authorities: - Expert - SilverMember - BronzeMember  ### Possible domain exceptions: 
     * @param id 
     * @param version 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public closeMemberGeneralMission(id: string, version?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<string>;
    public closeMemberGeneralMission(id: string, version?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<string>>;
    public closeMemberGeneralMission(id: string, version?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<string>>;
    public closeMemberGeneralMission(id: string, version?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling closeMemberGeneralMission.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (version !== undefined && version !== null) {
            localVarHeaders = localVarHeaders.set('Version', String(version));
        }

        let localVarCredential: string | undefined;
        // authentication (sprint-backoffice-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-backoffice-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-expert-manager-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-expert-manager-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-member-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-member-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-expert-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-expert-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/member-general-missions/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/close`;
        return this.httpClient.request<string>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * MemberGeneralMission 새롭게 생성
     * ### HasAny authorities: - Expert - SilverMember - BronzeMember  ### Possible domain exceptions: 
     * @param createMemberGeneralMissionRequest 
     * @param version 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createMemberGeneralMission(createMemberGeneralMissionRequest: CreateMemberGeneralMissionRequest, version?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<string>;
    public createMemberGeneralMission(createMemberGeneralMissionRequest: CreateMemberGeneralMissionRequest, version?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<string>>;
    public createMemberGeneralMission(createMemberGeneralMissionRequest: CreateMemberGeneralMissionRequest, version?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<string>>;
    public createMemberGeneralMission(createMemberGeneralMissionRequest: CreateMemberGeneralMissionRequest, version?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (createMemberGeneralMissionRequest === null || createMemberGeneralMissionRequest === undefined) {
            throw new Error('Required parameter createMemberGeneralMissionRequest was null or undefined when calling createMemberGeneralMission.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (version !== undefined && version !== null) {
            localVarHeaders = localVarHeaders.set('Version', String(version));
        }

        let localVarCredential: string | undefined;
        // authentication (sprint-backoffice-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-backoffice-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-expert-manager-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-expert-manager-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-member-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-member-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-expert-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-expert-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/member-general-missions`;
        return this.httpClient.request<string>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: createMemberGeneralMissionRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * DailyMemberGeneralMissionGroup을 date로 조회
     * ### HasAny authorities: - Admin - Expert - SilverMember - BronzeMember
     * @param date 
     * @param active 
     * @param statusType 
     * @param authorId 
     * @param ownerId 
     * @param expertMemberId 
     * @param version 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fetchDailyMemberGeneralMissionGroupByDate(date: string, active?: boolean, statusType?: MemberMissionStatusType, authorId?: string, ownerId?: string, expertMemberId?: string, version?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DailyMemberGeneralMissionGroupRecord>;
    public fetchDailyMemberGeneralMissionGroupByDate(date: string, active?: boolean, statusType?: MemberMissionStatusType, authorId?: string, ownerId?: string, expertMemberId?: string, version?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DailyMemberGeneralMissionGroupRecord>>;
    public fetchDailyMemberGeneralMissionGroupByDate(date: string, active?: boolean, statusType?: MemberMissionStatusType, authorId?: string, ownerId?: string, expertMemberId?: string, version?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DailyMemberGeneralMissionGroupRecord>>;
    public fetchDailyMemberGeneralMissionGroupByDate(date: string, active?: boolean, statusType?: MemberMissionStatusType, authorId?: string, ownerId?: string, expertMemberId?: string, version?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (date === null || date === undefined) {
            throw new Error('Required parameter date was null or undefined when calling fetchDailyMemberGeneralMissionGroupByDate.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (date !== undefined && date !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>date, 'date');
        }
        if (active !== undefined && active !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>active, 'active');
        }
        if (statusType !== undefined && statusType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>statusType, 'statusType');
        }
        if (authorId !== undefined && authorId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>authorId, 'authorId');
        }
        if (ownerId !== undefined && ownerId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>ownerId, 'ownerId');
        }
        if (expertMemberId !== undefined && expertMemberId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>expertMemberId, 'expertMemberId');
        }

        let localVarHeaders = this.defaultHeaders;
        if (version !== undefined && version !== null) {
            localVarHeaders = localVarHeaders.set('Version', String(version));
        }

        let localVarCredential: string | undefined;
        // authentication (sprint-backoffice-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-backoffice-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-expert-manager-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-expert-manager-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-member-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-member-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-expert-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-expert-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/member-general-missions/daily/group/date`;
        return this.httpClient.request<DailyMemberGeneralMissionGroupRecord>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * MemberGeneralMission List를 dateRange로 조회
     * ### HasAny authorities: - Admin - Expert - SilverMember - BronzeMember
     * @param from 
     * @param to 
     * @param active 
     * @param statusType 
     * @param authorId 
     * @param ownerId 
     * @param expertMemberId 
     * @param version 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fetchDailyMemberGeneralMissionGroupByDateRange(from: string, to: string, active?: boolean, statusType?: MemberMissionStatusType, authorId?: string, ownerId?: string, expertMemberId?: string, version?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<DailyMemberGeneralMissionGroupRecord>>;
    public fetchDailyMemberGeneralMissionGroupByDateRange(from: string, to: string, active?: boolean, statusType?: MemberMissionStatusType, authorId?: string, ownerId?: string, expertMemberId?: string, version?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<DailyMemberGeneralMissionGroupRecord>>>;
    public fetchDailyMemberGeneralMissionGroupByDateRange(from: string, to: string, active?: boolean, statusType?: MemberMissionStatusType, authorId?: string, ownerId?: string, expertMemberId?: string, version?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<DailyMemberGeneralMissionGroupRecord>>>;
    public fetchDailyMemberGeneralMissionGroupByDateRange(from: string, to: string, active?: boolean, statusType?: MemberMissionStatusType, authorId?: string, ownerId?: string, expertMemberId?: string, version?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (from === null || from === undefined) {
            throw new Error('Required parameter from was null or undefined when calling fetchDailyMemberGeneralMissionGroupByDateRange.');
        }
        if (to === null || to === undefined) {
            throw new Error('Required parameter to was null or undefined when calling fetchDailyMemberGeneralMissionGroupByDateRange.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (from !== undefined && from !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>from, 'from');
        }
        if (to !== undefined && to !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>to, 'to');
        }
        if (active !== undefined && active !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>active, 'active');
        }
        if (statusType !== undefined && statusType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>statusType, 'statusType');
        }
        if (authorId !== undefined && authorId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>authorId, 'authorId');
        }
        if (ownerId !== undefined && ownerId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>ownerId, 'ownerId');
        }
        if (expertMemberId !== undefined && expertMemberId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>expertMemberId, 'expertMemberId');
        }

        let localVarHeaders = this.defaultHeaders;
        if (version !== undefined && version !== null) {
            localVarHeaders = localVarHeaders.set('Version', String(version));
        }

        let localVarCredential: string | undefined;
        // authentication (sprint-backoffice-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-backoffice-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-expert-manager-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-expert-manager-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-member-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-member-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-expert-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-expert-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/member-general-missions/daily/group/date-range`;
        return this.httpClient.request<Array<DailyMemberGeneralMissionGroupRecord>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * MemberGeneralMission를 id로 조회
     * ### HasAny authorities: - Admin - Expert - SilverMember - BronzeMember
     * @param id 
     * @param version 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fetchMemberGeneralMissionById(id: string, version?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<MemberGeneralMissionRecord>;
    public fetchMemberGeneralMissionById(id: string, version?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MemberGeneralMissionRecord>>;
    public fetchMemberGeneralMissionById(id: string, version?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MemberGeneralMissionRecord>>;
    public fetchMemberGeneralMissionById(id: string, version?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling fetchMemberGeneralMissionById.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (version !== undefined && version !== null) {
            localVarHeaders = localVarHeaders.set('Version', String(version));
        }

        let localVarCredential: string | undefined;
        // authentication (sprint-backoffice-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-backoffice-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-expert-manager-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-expert-manager-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-member-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-member-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-expert-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-expert-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/member-general-missions/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        return this.httpClient.request<MemberGeneralMissionRecord>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * MemberGeneralMission Page 조회
     * ### HasAny authorities: - Admin - Expert - SilverMember - BronzeMember
     * @param active 
     * @param statusType 
     * @param authorId 
     * @param ownerId 
     * @param expertMemberId 
     * @param page Zero-based page index (0..N)
     * @param size The size of the page to be returned
     * @param sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param version 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fetchMemberGeneralMissionPage(active?: boolean, statusType?: MemberMissionStatusType, authorId?: string, ownerId?: string, expertMemberId?: string, page?: number, size?: number, sort?: Array<string>, version?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PageMemberGeneralMissionRecord>;
    public fetchMemberGeneralMissionPage(active?: boolean, statusType?: MemberMissionStatusType, authorId?: string, ownerId?: string, expertMemberId?: string, page?: number, size?: number, sort?: Array<string>, version?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PageMemberGeneralMissionRecord>>;
    public fetchMemberGeneralMissionPage(active?: boolean, statusType?: MemberMissionStatusType, authorId?: string, ownerId?: string, expertMemberId?: string, page?: number, size?: number, sort?: Array<string>, version?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PageMemberGeneralMissionRecord>>;
    public fetchMemberGeneralMissionPage(active?: boolean, statusType?: MemberMissionStatusType, authorId?: string, ownerId?: string, expertMemberId?: string, page?: number, size?: number, sort?: Array<string>, version?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (active !== undefined && active !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>active, 'active');
        }
        if (statusType !== undefined && statusType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>statusType, 'statusType');
        }
        if (authorId !== undefined && authorId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>authorId, 'authorId');
        }
        if (ownerId !== undefined && ownerId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>ownerId, 'ownerId');
        }
        if (expertMemberId !== undefined && expertMemberId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>expertMemberId, 'expertMemberId');
        }
        if (page !== undefined && page !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>page, 'page');
        }
        if (size !== undefined && size !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>size, 'size');
        }
        if (sort) {
            sort.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'sort');
            })
        }

        let localVarHeaders = this.defaultHeaders;
        if (version !== undefined && version !== null) {
            localVarHeaders = localVarHeaders.set('Version', String(version));
        }

        let localVarCredential: string | undefined;
        // authentication (sprint-backoffice-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-backoffice-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-expert-manager-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-expert-manager-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-member-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-member-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-expert-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-expert-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/member-general-missions/page`;
        return this.httpClient.request<PageMemberGeneralMissionRecord>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * MemberGeneralMission Slice 조회
     * ### HasAny authorities: - Admin - Expert - SilverMember - BronzeMember
     * @param active 
     * @param statusType 
     * @param authorId 
     * @param ownerId 
     * @param expertMemberId 
     * @param page Zero-based page index (0..N)
     * @param size The size of the page to be returned
     * @param sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param version 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fetchMemberGeneralMissionSlice(active?: boolean, statusType?: MemberMissionStatusType, authorId?: string, ownerId?: string, expertMemberId?: string, page?: number, size?: number, sort?: Array<string>, version?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SliceMemberGeneralMissionRecord>;
    public fetchMemberGeneralMissionSlice(active?: boolean, statusType?: MemberMissionStatusType, authorId?: string, ownerId?: string, expertMemberId?: string, page?: number, size?: number, sort?: Array<string>, version?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SliceMemberGeneralMissionRecord>>;
    public fetchMemberGeneralMissionSlice(active?: boolean, statusType?: MemberMissionStatusType, authorId?: string, ownerId?: string, expertMemberId?: string, page?: number, size?: number, sort?: Array<string>, version?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SliceMemberGeneralMissionRecord>>;
    public fetchMemberGeneralMissionSlice(active?: boolean, statusType?: MemberMissionStatusType, authorId?: string, ownerId?: string, expertMemberId?: string, page?: number, size?: number, sort?: Array<string>, version?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (active !== undefined && active !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>active, 'active');
        }
        if (statusType !== undefined && statusType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>statusType, 'statusType');
        }
        if (authorId !== undefined && authorId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>authorId, 'authorId');
        }
        if (ownerId !== undefined && ownerId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>ownerId, 'ownerId');
        }
        if (expertMemberId !== undefined && expertMemberId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>expertMemberId, 'expertMemberId');
        }
        if (page !== undefined && page !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>page, 'page');
        }
        if (size !== undefined && size !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>size, 'size');
        }
        if (sort) {
            sort.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'sort');
            })
        }

        let localVarHeaders = this.defaultHeaders;
        if (version !== undefined && version !== null) {
            localVarHeaders = localVarHeaders.set('Version', String(version));
        }

        let localVarCredential: string | undefined;
        // authentication (sprint-backoffice-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-backoffice-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-expert-manager-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-expert-manager-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-member-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-member-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-expert-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-expert-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/member-general-missions/slice`;
        return this.httpClient.request<SliceMemberGeneralMissionRecord>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * MemberGeneralMission List를 date로 조회
     * ### HasAny authorities: - Admin - Expert - SilverMember - BronzeMember
     * @param date 
     * @param active 
     * @param statusType 
     * @param authorId 
     * @param ownerId 
     * @param expertMemberId 
     * @param version 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fetchMemberGeneralMissionsByDate(date: string, active?: boolean, statusType?: MemberMissionStatusType, authorId?: string, ownerId?: string, expertMemberId?: string, version?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<MemberGeneralMissionRecord>>;
    public fetchMemberGeneralMissionsByDate(date: string, active?: boolean, statusType?: MemberMissionStatusType, authorId?: string, ownerId?: string, expertMemberId?: string, version?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<MemberGeneralMissionRecord>>>;
    public fetchMemberGeneralMissionsByDate(date: string, active?: boolean, statusType?: MemberMissionStatusType, authorId?: string, ownerId?: string, expertMemberId?: string, version?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<MemberGeneralMissionRecord>>>;
    public fetchMemberGeneralMissionsByDate(date: string, active?: boolean, statusType?: MemberMissionStatusType, authorId?: string, ownerId?: string, expertMemberId?: string, version?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (date === null || date === undefined) {
            throw new Error('Required parameter date was null or undefined when calling fetchMemberGeneralMissionsByDate.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (date !== undefined && date !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>date, 'date');
        }
        if (active !== undefined && active !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>active, 'active');
        }
        if (statusType !== undefined && statusType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>statusType, 'statusType');
        }
        if (authorId !== undefined && authorId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>authorId, 'authorId');
        }
        if (ownerId !== undefined && ownerId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>ownerId, 'ownerId');
        }
        if (expertMemberId !== undefined && expertMemberId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>expertMemberId, 'expertMemberId');
        }

        let localVarHeaders = this.defaultHeaders;
        if (version !== undefined && version !== null) {
            localVarHeaders = localVarHeaders.set('Version', String(version));
        }

        let localVarCredential: string | undefined;
        // authentication (sprint-backoffice-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-backoffice-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-expert-manager-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-expert-manager-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-member-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-member-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-expert-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-expert-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/member-general-missions/date`;
        return this.httpClient.request<Array<MemberGeneralMissionRecord>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 현재 진행중인 MemberGeneralMission 쿼리
     * ### HasAny authorities: - Admin - Expert - SilverMember - BronzeMember
     * @param active 
     * @param statusType 
     * @param authorId 
     * @param ownerId 
     * @param expertMemberId 
     * @param sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param version 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fetchOngoingMemberGeneralMissions(active?: boolean, statusType?: MemberMissionStatusType, authorId?: string, ownerId?: string, expertMemberId?: string, sort?: Array<string>, version?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<MemberGeneralMissionRecord>>;
    public fetchOngoingMemberGeneralMissions(active?: boolean, statusType?: MemberMissionStatusType, authorId?: string, ownerId?: string, expertMemberId?: string, sort?: Array<string>, version?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<MemberGeneralMissionRecord>>>;
    public fetchOngoingMemberGeneralMissions(active?: boolean, statusType?: MemberMissionStatusType, authorId?: string, ownerId?: string, expertMemberId?: string, sort?: Array<string>, version?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<MemberGeneralMissionRecord>>>;
    public fetchOngoingMemberGeneralMissions(active?: boolean, statusType?: MemberMissionStatusType, authorId?: string, ownerId?: string, expertMemberId?: string, sort?: Array<string>, version?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (active !== undefined && active !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>active, 'active');
        }
        if (statusType !== undefined && statusType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>statusType, 'statusType');
        }
        if (authorId !== undefined && authorId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>authorId, 'authorId');
        }
        if (ownerId !== undefined && ownerId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>ownerId, 'ownerId');
        }
        if (expertMemberId !== undefined && expertMemberId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>expertMemberId, 'expertMemberId');
        }
        if (sort) {
            sort.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'sort');
            })
        }

        let localVarHeaders = this.defaultHeaders;
        if (version !== undefined && version !== null) {
            localVarHeaders = localVarHeaders.set('Version', String(version));
        }

        let localVarCredential: string | undefined;
        // authentication (sprint-backoffice-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-backoffice-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-expert-manager-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-expert-manager-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-member-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-member-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-expert-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-expert-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/member-general-missions/ongoing`;
        return this.httpClient.request<Array<MemberGeneralMissionRecord>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * MemberGeneralMission 비활성화
     * ### HasAny authorities: - Expert - SilverMember - BronzeMember  ### Possible domain exceptions: 
     * @param id 
     * @param version 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public inactivateMemberGeneralMission(id: string, version?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<string>;
    public inactivateMemberGeneralMission(id: string, version?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<string>>;
    public inactivateMemberGeneralMission(id: string, version?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<string>>;
    public inactivateMemberGeneralMission(id: string, version?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling inactivateMemberGeneralMission.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (version !== undefined && version !== null) {
            localVarHeaders = localVarHeaders.set('Version', String(version));
        }

        let localVarCredential: string | undefined;
        // authentication (sprint-backoffice-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-backoffice-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-expert-manager-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-expert-manager-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-member-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-member-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-expert-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-expert-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/member-general-missions/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/inactivate`;
        return this.httpClient.request<string>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Mission의 완료를 날짜별로 삭제합니다.
     * ### HasAny authorities: - Admin - Expert - SilverMember - BronzeMember  ### Possible domain exceptions: 
     * @param id 
     * @param removeMemberGeneralMissionCompletionByDateRequest 
     * @param version 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeMemberGeneralMissionCompletionByDate(id: string, removeMemberGeneralMissionCompletionByDateRequest: RemoveMemberGeneralMissionCompletionByDateRequest, version?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<string>;
    public removeMemberGeneralMissionCompletionByDate(id: string, removeMemberGeneralMissionCompletionByDateRequest: RemoveMemberGeneralMissionCompletionByDateRequest, version?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<string>>;
    public removeMemberGeneralMissionCompletionByDate(id: string, removeMemberGeneralMissionCompletionByDateRequest: RemoveMemberGeneralMissionCompletionByDateRequest, version?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<string>>;
    public removeMemberGeneralMissionCompletionByDate(id: string, removeMemberGeneralMissionCompletionByDateRequest: RemoveMemberGeneralMissionCompletionByDateRequest, version?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling removeMemberGeneralMissionCompletionByDate.');
        }
        if (removeMemberGeneralMissionCompletionByDateRequest === null || removeMemberGeneralMissionCompletionByDateRequest === undefined) {
            throw new Error('Required parameter removeMemberGeneralMissionCompletionByDateRequest was null or undefined when calling removeMemberGeneralMissionCompletionByDate.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (version !== undefined && version !== null) {
            localVarHeaders = localVarHeaders.set('Version', String(version));
        }

        let localVarCredential: string | undefined;
        // authentication (sprint-backoffice-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-backoffice-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-expert-manager-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-expert-manager-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-member-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-member-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-expert-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-expert-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/member-general-missions/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/completions`;
        return this.httpClient.request<string>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: removeMemberGeneralMissionCompletionByDateRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * MemberGeneralMission 업데이트
     * ### HasAny authorities: - Expert - SilverMember - BronzeMember  ### Possible domain exceptions: 
     * @param id 
     * @param updateMemberGeneralMissionRequest 
     * @param version 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateMemberGeneralMission(id: string, updateMemberGeneralMissionRequest: UpdateMemberGeneralMissionRequest, version?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<string>;
    public updateMemberGeneralMission(id: string, updateMemberGeneralMissionRequest: UpdateMemberGeneralMissionRequest, version?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<string>>;
    public updateMemberGeneralMission(id: string, updateMemberGeneralMissionRequest: UpdateMemberGeneralMissionRequest, version?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<string>>;
    public updateMemberGeneralMission(id: string, updateMemberGeneralMissionRequest: UpdateMemberGeneralMissionRequest, version?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateMemberGeneralMission.');
        }
        if (updateMemberGeneralMissionRequest === null || updateMemberGeneralMissionRequest === undefined) {
            throw new Error('Required parameter updateMemberGeneralMissionRequest was null or undefined when calling updateMemberGeneralMission.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (version !== undefined && version !== null) {
            localVarHeaders = localVarHeaders.set('Version', String(version));
        }

        let localVarCredential: string | undefined;
        // authentication (sprint-backoffice-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-backoffice-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-expert-manager-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-expert-manager-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-member-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-member-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-expert-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-expert-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/member-general-missions/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        return this.httpClient.request<string>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: updateMemberGeneralMissionRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * MemberGeneralMission의 반복패턴 수정
     * ### HasAny authorities: - Expert - SilverMember - BronzeMember  ### Possible domain exceptions: 
     * @param id 
     * @param updateMemberGeneralMissionRecurrencePatternRequest 
     * @param version 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateMemberGeneralMissionRecurrencePattern(id: string, updateMemberGeneralMissionRecurrencePatternRequest: UpdateMemberGeneralMissionRecurrencePatternRequest, version?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<string>;
    public updateMemberGeneralMissionRecurrencePattern(id: string, updateMemberGeneralMissionRecurrencePatternRequest: UpdateMemberGeneralMissionRecurrencePatternRequest, version?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<string>>;
    public updateMemberGeneralMissionRecurrencePattern(id: string, updateMemberGeneralMissionRecurrencePatternRequest: UpdateMemberGeneralMissionRecurrencePatternRequest, version?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<string>>;
    public updateMemberGeneralMissionRecurrencePattern(id: string, updateMemberGeneralMissionRecurrencePatternRequest: UpdateMemberGeneralMissionRecurrencePatternRequest, version?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateMemberGeneralMissionRecurrencePattern.');
        }
        if (updateMemberGeneralMissionRecurrencePatternRequest === null || updateMemberGeneralMissionRecurrencePatternRequest === undefined) {
            throw new Error('Required parameter updateMemberGeneralMissionRecurrencePatternRequest was null or undefined when calling updateMemberGeneralMissionRecurrencePattern.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (version !== undefined && version !== null) {
            localVarHeaders = localVarHeaders.set('Version', String(version));
        }

        let localVarCredential: string | undefined;
        // authentication (sprint-backoffice-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-backoffice-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-expert-manager-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-expert-manager-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-member-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-member-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-expert-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-expert-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/member-general-missions/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/recurrence-pattern`;
        return this.httpClient.request<string>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: updateMemberGeneralMissionRecurrencePatternRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Mission의 특정 날짜에 완료 체크합니다.
     * ### HasAny authorities: - Admin - Expert - SilverMember - BronzeMember  ### Possible domain exceptions: 
     * @param id 
     * @param upsertMemberGeneralMissionCompletionByDateRequest 
     * @param version 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public upsertMemberGeneralMissionCompletionByDate(id: string, upsertMemberGeneralMissionCompletionByDateRequest: UpsertMemberGeneralMissionCompletionByDateRequest, version?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<string>;
    public upsertMemberGeneralMissionCompletionByDate(id: string, upsertMemberGeneralMissionCompletionByDateRequest: UpsertMemberGeneralMissionCompletionByDateRequest, version?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<string>>;
    public upsertMemberGeneralMissionCompletionByDate(id: string, upsertMemberGeneralMissionCompletionByDateRequest: UpsertMemberGeneralMissionCompletionByDateRequest, version?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<string>>;
    public upsertMemberGeneralMissionCompletionByDate(id: string, upsertMemberGeneralMissionCompletionByDateRequest: UpsertMemberGeneralMissionCompletionByDateRequest, version?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling upsertMemberGeneralMissionCompletionByDate.');
        }
        if (upsertMemberGeneralMissionCompletionByDateRequest === null || upsertMemberGeneralMissionCompletionByDateRequest === undefined) {
            throw new Error('Required parameter upsertMemberGeneralMissionCompletionByDateRequest was null or undefined when calling upsertMemberGeneralMissionCompletionByDate.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (version !== undefined && version !== null) {
            localVarHeaders = localVarHeaders.set('Version', String(version));
        }

        let localVarCredential: string | undefined;
        // authentication (sprint-backoffice-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-backoffice-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-expert-manager-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-expert-manager-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-member-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-member-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (sprint-expert-app-oauth2) required
        localVarCredential = this.configuration.lookupCredential('sprint-expert-app-oauth2');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/member-general-missions/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/completions`;
        return this.httpClient.request<string>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: upsertMemberGeneralMissionCompletionByDateRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
